// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__rYTwb","main":"Layout_main__T84kS"};